import { render, staticRenderFns } from "./assign-product-product-groups.vue?vue&type=template&id=74b2c020&"
import script from "./assign-product-product-groups.vue?vue&type=script&lang=js&"
export * from "./assign-product-product-groups.vue?vue&type=script&lang=js&"
import style0 from "./assign-product-product-groups.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports